// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let CopyMarketingProfileLinkButton_urlDetails_graphql = require("../../__generated__/CopyMarketingProfileLinkButton_urlDetails_graphql.bs.js");

let convertFragment = CopyMarketingProfileLinkButton_urlDetails_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, CopyMarketingProfileLinkButton_urlDetails_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(CopyMarketingProfileLinkButton_urlDetails_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, CopyMarketingProfileLinkButton_urlDetails_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(CopyMarketingProfileLinkButton_urlDetails_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function baseUrlWithoutProtocol(url) {
  let baseUrl = Scalars.URL.toWebapiUrl(url);
  return baseUrl.host + baseUrl.pathname;
}

function CopyMarketingProfileLinkButton(props) {
  let match = RescriptRelay_Fragment.useFragment(CopyMarketingProfileLinkButton_urlDetails_graphql.node, convertFragment, props.urlDetails);
  let slug = match.slug;
  let baseUrl = baseUrlWithoutProtocol(match.baseUrl);
  let match$1 = React.useState(() => "Neutral");
  let setState = match$1[1];
  let state = match$1[0];
  let timeoutRef = React.useRef(undefined);
  let copy = React.useCallback(() => window.navigator.clipboard.writeText(baseUrl + `/` + slug).then(() => {
    setState(param => "Confirming");
    let timeoutId = setTimeout(() => setState(param => "Neutral"), 2000);
    timeoutRef.current = Primitive_option.some(timeoutId);
    return Promise.resolve();
  }), []);
  React.useEffect(() => (() => {
    let timeoutId = timeoutRef.current;
    if (timeoutId !== undefined) {
      clearTimeout(Primitive_option.valFromOption(timeoutId));
      return;
    }
  }), []);
  let tmp;
  tmp = state === "Neutral" ? JsxRuntime.jsx("div", {
      children: "Copy",
      className: "font-semibold text-gray-800 uppercase"
    }) : JsxRuntime.jsx("div", {
      children: "Copied!",
      className: "font-semibold text-green-800 uppercase"
    });
  return JsxRuntime.jsx("button", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(IconV5.make, {
              icon: "link",
              className: "text-gray-700 w-4 h-4"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                baseUrl + `/`,
                JsxRuntime.jsx("wbr", {}),
                slug
              ],
              className: "text-gray-700"
            })
          ],
          className: "flex gap-4 items-center"
        }),
        tmp
      ],
      className: "flex justify-between items-center gap-4"
    }),
    className: "border rounded-lg py-3 px-3 hover:bg-gray-100 w-full",
    onClick: param => {
      if (state === "Neutral") {
        copy();
        return;
      }
    }
  });
}

let make = CopyMarketingProfileLinkButton;

exports.Fragment = Fragment;
exports.baseUrlWithoutProtocol = baseUrlWithoutProtocol;
exports.make = make;
/* react Not a pure module */
